import { render, staticRenderFns } from "./ESituacaoPlanoInfantil.vue?vue&type=template&id=db45f518"
import script from "./ESituacaoPlanoInfantil.vue?vue&type=script&lang=js"
export * from "./ESituacaoPlanoInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports